import { NavigationBar } from '@travelnest/hui';
import { Rule } from '@travelnest/merlin.rule';
import { IProperty } from '../../../data/entities/property';

import * as React from 'react';
import { IAvailabilityV3BookingsResponse, IBookingsByOwnerIdParams } from '../../../api/bookings';
import { BookingList } from '../../components/booking-list/BookingList';
import { ExpandingMenu } from '../../components/expanding-menu/ExpandingMenu';
import { ExpandingMenuItem } from '../../components/expanding-menu/ExpandingMenuItem';
import { Loader } from '../../components/loader/Loader';

export interface IOwnerBookingListProps {
	bookings: IAvailabilityV3BookingsResponse | undefined;
	properties: IProperty[];
	loading: boolean;
	currentQueryParams: IBookingsByOwnerIdParams;
	onUpdateQueryParams(params: Partial<IBookingsByOwnerIdParams>): void;
}
export const OwnerBookingsListComponent: React.FC<IOwnerBookingListProps> = (props) => {
	const { currentQueryParams, onUpdateQueryParams, bookings, properties, loading } = props;
	const eventStatus = currentQueryParams.event_status || [];
	const timePeriod = currentQueryParams.time_period || [];
	const showCancelled = currentQueryParams.event_status?.includes('cancelled') || false;
	const showFuture = currentQueryParams.time_period?.includes('future') || false;
	const showPresent = currentQueryParams.time_period?.includes('present') || false;
	const showPast = currentQueryParams.time_period?.includes('past') || false;
	return (
		<>
			<NavigationBar title="Bookings" />
			<div className="portal-wrapper">
				<div className="cont-head__rhs-content--align-right" style={{ float: 'right' }}>
					<ExpandingMenu>
						<ExpandingMenuItem guttered={true} selected={showFuture}
							onClick={
								() => onUpdateQueryParams(
									{
										time_period: showFuture
											? currentQueryParams.time_period?.filter((e) => e !== 'future')
											: [...timePeriod, 'future'],
									}
								)
							}>Show future</ExpandingMenuItem>
						<ExpandingMenuItem guttered={true} selected={showPresent}
							onClick={
								() => onUpdateQueryParams(
									{
										time_period: showPresent
											? currentQueryParams.time_period?.filter((e) => e !== 'present')
											: [...timePeriod, 'present'],
									}
								)
							}>Show current</ExpandingMenuItem>
						<ExpandingMenuItem guttered={true} selected={showPast}
							onClick={
								() => onUpdateQueryParams(
									{
										time_period: showPast
											? currentQueryParams.time_period?.filter((e) => e !== 'past')
											: [...timePeriod, 'past'],
									}
								)
							}>Show completed</ExpandingMenuItem>
						<ExpandingMenuItem guttered={true} ><Rule /></ExpandingMenuItem>
						<ExpandingMenuItem guttered={true} selected={showCancelled}
							onClick={
								() => onUpdateQueryParams(
									{
										event_status: showCancelled
											? currentQueryParams.event_status?.filter((e) => e !== 'cancelled')
											: [...eventStatus, 'cancelled'],
									}
								)
							}
						>
							Show cancelled
						</ExpandingMenuItem>
						<ExpandingMenuItem guttered={true} ><Rule /></ExpandingMenuItem>
						<ExpandingMenuItem guttered={true} selected={currentQueryParams.sort_direction === 'ascending'}
							onClick={() => onUpdateQueryParams({ sort_direction: 'ascending' })}>Sort Arriving First</ExpandingMenuItem>
						<ExpandingMenuItem guttered={true} selected={currentQueryParams.sort_direction === 'descending'}
							onClick={() => onUpdateQueryParams({ sort_direction: 'descending' })}>Sort Arriving Last</ExpandingMenuItem>
					</ExpandingMenu></div>
				{
					loading ? <Loader message={'Your bookings are loading.'} loading /> :
						<BookingList
							bookings={bookings}
							properties={properties}
							loading={loading}
							paginate={(pageNumber: number) => onUpdateQueryParams({ page_number: pageNumber })}
						/>
				}
			</div>
		</>
	);
};
